import { Url } from 'next/dist/shared/lib/router/router';

import { publicEnv } from '@/lib/env';

const SSO_BASE = publicEnv.NEXT_PUBLIC_SSO_URL;

export const isSsoURL = (url: string | URL | Url) => {
  if (!SSO_BASE) return false;

  if (typeof url === 'string') {
    return url.includes(SSO_BASE);
  }

  return url ? (url.href ? url.href.includes(SSO_BASE) : false) : false;
};
